(() => {
  const CUR_KEY = "sf-currency";
  const readCurrency = () => {
    try {
      const stored = localStorage.getItem(CUR_KEY);
      if (stored === "USD" || stored === "BRL" || stored === "GYD") return stored;
    } catch (e) {}
    return "GYD";
  };
  let currency = readCurrency();
  const COUNTRY = { GYD: "GY", USD: "US", BRL: "BR" };
  const shopCurrency = () => String(
    window.theme?.market?.currency || window.Shopify?.currency?.active || "GYD"
  ).toUpperCase();
  const rateOf = (code) => {
    const rates = window.theme?.rates || {};
    const usd = Number(String(rates.usd || "220").replace(/,/g, "")) || 220;
    const brl = Number(String(rates.brl || "49").replace(/,/g, "")) || 49;
    return code === "USD" ? usd : code === "BRL" ? brl : 1;
  };
  const roundToOne = (value) => {
    const n = Number(value) || 0;
    if (n <= 0) return 0;
    return Math.ceil(n);
  };
  const money = (cents) => {
    const major = (Number(cents) || 0) / 100;
    const shop = shopCurrency();
    if (currency === "USD") {
      const usd = shop === "USD" ? major : major / rateOf("USD");
      return `US$${roundToOne(usd).toLocaleString("en-US")}`;
    }
    if (currency === "BRL") {
      const brl = shop === "BRL" ? major : major / rateOf("BRL");
      return `R$${roundToOne(brl).toLocaleString("pt-BR")}`;
    }
    const gyd = shop === "GYD" ? major : shop === "USD" ? major * rateOf("USD") : major * rateOf("BRL");
    return `G$${Math.round(gyd).toLocaleString("en-US")}`;
  };
  const closePrefMenus = () => {
    document.querySelectorAll(".pref-menu.is-open").forEach((menu) => {
      menu.classList.remove("is-open");
      const toggle = menu.querySelector("[data-pref-toggle]");
      const list = menu.querySelector(".pref-list");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      if (list) list.hidden = true;
    });
  };
  const syncPrefMenu = (menu, value) => {
    const opt = menu.querySelector(`[data-lang-pick="${value}"], [data-currency-pick="${value}"]`);
    const toggle = menu.querySelector("[data-pref-toggle]");
    if (!opt || !toggle) return;
    const flag = opt.querySelector(".flag");
    const flagHost = toggle.querySelector("[data-pref-flag]");
    const codeHost = toggle.querySelector("[data-pref-code]");
    if (flag && flagHost) flagHost.innerHTML = flag.outerHTML;
    if (codeHost) codeHost.textContent = opt.getAttribute("data-label") || value;
    menu.querySelectorAll("[data-lang-pick], [data-currency-pick]").forEach((btn) => {
      btn.setAttribute("aria-current", btn === opt ? "true" : "false");
    });
  };
  const paintPrefs = () => {
    document.querySelectorAll('[data-pref="currency"]').forEach((menu) => syncPrefMenu(menu, currency));
    document.querySelectorAll('[data-pref="lang"]').forEach((menu) => {
      syncPrefMenu(menu, window.themeI18n?.lang?.() || "en");
    });
  };
  const paintMoney = () => {
    document.querySelectorAll("[data-money][data-cents]").forEach((el) => {
      el.textContent = money(el.dataset.cents);
    });
    const t = window.themeI18n?.t || ((k) => k);
    document.querySelectorAll(".badge-save[data-cents]").forEach((el) => {
      el.textContent = `${t("save")} ${money(el.dataset.cents)}`;
    });
    document.querySelectorAll("[data-currency-switch]").forEach((sel) => { sel.value = currency; });
    paintPrefs();
  };
  const marketCountry = (code) => COUNTRY[code] || "GY";
  const marketAvailable = (country) => {
    const countries = window.theme?.market?.countries || [];
    if (!countries.length) return false;
    return countries.some((row) => String(row.iso || "").toUpperCase() === country);
  };
  const submitMarket = (code, returnTo) => {
    const country = marketCountry(code);
    const form = document.getElementById("SfLocalization");
    const input = document.getElementById("SfCountry");
    if (!form || !input) return false;
    if (!marketAvailable(country)) return false;
    input.value = country;
    if (returnTo) {
      let ret = form.querySelector('[name="return_to"]');
      if (!ret) {
        ret = document.createElement("input");
        ret.type = "hidden";
        ret.name = "return_to";
        form.appendChild(ret);
      }
      ret.value = returnTo;
    }
    form.submit();
    return true;
  };
  window.themeMoney = money;
  window.themePrefs = { paint: paintPrefs, close: closePrefMenus };
  window.themeFx = {
    currency: () => currency,
    shopCurrency,
    toCents(display) {
      const amount = Number(display);
      if (!Number.isFinite(amount) || amount < 0) return null;
      if (currency === "USD") return Math.round(amount * rateOf("USD") * 100);
      if (currency === "BRL") return Math.round(amount * rateOf("BRL") * 100);
      return Math.round(amount * 100);
    },
    checkoutIn(code) {
      const next = code === "USD" || code === "BRL" ? code : "GYD";
      if (shopCurrency() === next) return false;
      return submitMarket(next, "/checkout");
    },
    set(next) {
      currency = next === "USD" || next === "BRL" ? next : "GYD";
      try { localStorage.setItem(CUR_KEY, currency); } catch (e) {}
      paintMoney();
      document.dispatchEvent(new CustomEvent("sf-currency", { detail: currency }));
      const country = marketCountry(currency);
      const current = String(window.theme?.market?.country || "").toUpperCase();
      if (country !== current && marketAvailable(country)) submitMarket(currency);
    },
    paint: paintMoney
  };
  document.addEventListener("click", (event) => {
    const toggle = event.target.closest("[data-pref-toggle]");
    if (toggle) {
      const menu = toggle.closest(".pref-menu");
      const open = !menu.classList.contains("is-open");
      closePrefMenus();
      if (open) {
        menu.classList.add("is-open");
        toggle.setAttribute("aria-expanded", "true");
        const list = menu.querySelector(".pref-list");
        if (list) list.hidden = false;
      }
      return;
    }
    const langPick = event.target.closest("[data-lang-pick]");
    if (langPick) {
      window.themeI18n?.set(langPick.getAttribute("data-lang-pick"));
      closePrefMenus();
      return;
    }
    const curPick = event.target.closest("[data-currency-pick]");
    if (curPick) {
      window.themeFx.set(curPick.getAttribute("data-currency-pick"));
      closePrefMenus();
      return;
    }
    if (!event.target.closest(".pref-menu")) closePrefMenus();
  });
  document.addEventListener("change", (event) => {
    const sel = event.target.closest("[data-currency-switch]");
    if (sel) window.themeFx.set(sel.value);
  });
  document.addEventListener("sf-lang", paintPrefs);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", paintMoney);
  } else {
    paintMoney();
  }

  const LOW_STOCK = Number(window.theme?.lowStock) || 3;
  const escapeCard = (value) => String(value || "").replace(/[&<>"']/g, (char) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
  }[char]));

  window.themeCard = {
    badges(row) {
      const bits = [];
      if (!row.available) bits.push(`<span class="badge badge-sold">${(window.themeI18n?.t || ((k) => k))("out_of_stock")}</span>`);
      const price = Number(row.price) || 0;
      const compare = Number(row.compare_at) || 0;
      if (compare > price) {
        const t = window.themeI18n?.t || ((k) => k);
        bits.push(`<span class="badge badge-sale">${t("sale")}</span>`);
        bits.push(`<span class="badge badge-save" data-cents="${compare - price}">${t("save")} ${money(compare - price)}</span>`);
      }
      const qty = Number(row.qty);
      if (row.available && row.tracks && qty > 0 && qty <= LOW_STOCK) {
        bits.push('<span class="badge badge-low">Low stock</span>');
      }
      return `<div class="product-badges">${bits.join("")}</div>`;
    },
    stock(row) {
      const t = window.themeI18n?.t || ((k) => k);
      if (!row.available) return `<p class="stock-note stock-sold">${t("out_of_stock")}</p>`;
      const qty = Number(row.qty);
      if (row.tracks && qty > 0 && qty <= LOW_STOCK) return `<p class="stock-note">${t("low_stock")}</p>`;
      return `<p class="stock-note stock-ok">${t("in_stock")}</p>`;
    },
    html(row, attrs = "") {
      const t = window.themeI18n?.t || ((k) => k);
      const cents = Number(row.price) || 0;
      const compare = Number(row.compare_at) || 0;
      const price = compare > cents
        ? `<div class="price-row"><s class="price-compare" data-money data-cents="${compare}">${money(compare)}</s> <span class="price price-sale" data-money data-cents="${cents}">${money(cents)}</span></div>`
        : `<div class="price-row"><span class="price" data-money data-cents="${cents}">${money(cents)}</span></div>`;
      let media = row.image ? `<img src="${escapeCard(row.image)}" alt="" loading="lazy">` : "";
      if (row.video_url) {
        media = `<video class="card-media-video" src="${escapeCard(row.video_url)}" poster="${escapeCard(row.image || "")}" autoplay muted loop playsinline></video>`;
      } else if (row.model_url) {
        media = `<model-viewer src="${escapeCard(row.model_url)}" poster="${escapeCard(row.image || "")}" camera-controls auto-rotate interaction-prompt="none"></model-viewer><span class="media-badge">3D</span>`;
      } else if (row.media_type === "external_video" && row.image) {
        media = `<img src="${escapeCard(row.image)}" alt="" loading="lazy"><span class="media-badge">Video</span>`;
      }
      return `<article class="product-card${row.available ? "" : " is-sold-out"}" ${attrs}>
        <a href="${escapeCard(row.url)}">
          <div class="media">${this.badges(row)}${media}</div>
          <div class="info">
            ${window.themeBrand?.markup(row.title, row.vendor) || ""}
            <h3>${escapeCard(row.title)}</h3>
            ${price}
            ${this.stock(row)}
          </div>
        </a>
        <div class="card-actions">
          <button class="chip-btn" type="button" data-add-compare data-handle="${escapeCard(row.handle)}" data-title="${escapeCard(row.title)}" data-image="${escapeCard(row.image || "")}">${t("add_compare")}</button>
        </div>
      </article>`;
    }
  };

  const BRANDS = [
    { test: /iphone|ipad|macbook|airpods|\bapple\b/i, name: "Apple", icon: "apple" },
    { test: /samsung|\bgalaxy\b/i, name: "Samsung", icon: "samsung" },
    { test: /\bxiaomi\b/i, name: "Xiaomi", icon: "xiaomi" },
    { test: /\bredmi\b/i, name: "Redmi", icon: "xiaomi" },
    { test: /\bpoco\b/i, name: "Poco", icon: "xiaomi" },
    { test: /\boneplus\b/i, name: "OnePlus", icon: "oneplus" },
    { test: /\bmicrosoft\b/i, name: "Microsoft", icon: "microsoft" },
    { test: /\bmotorola\b/i, name: "Motorola", icon: "motorola" },
    { test: /\bamazon\b/i, name: "Amazon", icon: "amazon" },
    { test: /\bhuawei\b/i, name: "Huawei", icon: "huawei" },
    { test: /\bgoogle\b/i, name: "Google", icon: "google" },
    { test: /\binfinix\b/i, name: "Infinix" },
    { test: /\blenovo\b/i, name: "Lenovo", icon: "lenovo" },
    { test: /\bnokia\b/i, name: "Nokia", icon: "nokia" },
    { test: /\bsony\b/i, name: "Sony", icon: "sony" },
    { test: /\boppo\b/i, name: "Oppo", icon: "oppo" },
    { test: /\basus\b|vivobook|zenbook|\brog\b/i, name: "Asus", icon: "asus" },
    { test: /\bacer\b|\baspire\b|\bpredator\b/i, name: "Acer", icon: "acer" },
    { test: /\bdell\b|inspiron|latitude|alienware/i, name: "Dell", icon: "dell" },
    { test: /\bhp\b|hewlett|omnibook|pavilion/i, name: "HP", icon: "hp" },
    { test: /\bvivo\b/i, name: "Vivo", icon: "vivo" },
    { test: /\bmsi\b/i, name: "MSI" },
    { test: /\bhonor\b/i, name: "Honor", icon: "honor" },
    { test: /\brealme\b/i, name: "Realme", icon: "realme" },
    { test: /\btecno\b/i, name: "Tecno" },
    { test: /\bcubot\b/i, name: "Cubot" },
    { test: /\bbmax\b/i, name: "Bmax" },
    { test: /\bblu\b/i, name: "Blu" },
    { test: /\bfossibot\b/i, name: "Fossibot" },
    { test: /\bhotwav\b/i, name: "Hotwav" }
  ];

  window.themeBrand = {
    identify(title, vendor) {
      const hay = `${vendor || ""} ${title || ""}`;
      const hit = BRANDS.find((brand) => brand.test.test(hay));
      if (hit) return { name: hit.name, icon: hit.icon || "" };
      const vendorName = String(vendor || "").trim();
      if (vendorName && !/smart\s*fix/i.test(vendorName)) return { name: vendorName, icon: "" };
      const first = String(title || "").trim().split(/\s+/)[0] || "";
      if (first && !/^\d/.test(first) && !/^(usb|cable|case|cover|screen|charger|tablet|laptop|phone|wireless|type)$/i.test(first)) {
        return { name: first, icon: "" };
      }
      return { name: "", icon: "" };
    },
    markup(title, vendor) {
      const { name } = this.identify(title, vendor);
      if (!name) return "";
      const safe = String(name).replace(/[&<>"']/g, (char) => ({
        "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
      }[char]));
      return `<div class="card-brand"><span class="card-brand-name">${safe}</span></div>`;
    }
  };

  const THEME_KEY = "sf-theme";
  const syncThemeTabs = (theme) => {
    document.querySelectorAll("[data-theme-switch] [data-theme-value]").forEach((btn) => {
      btn.setAttribute("aria-selected", String(btn.getAttribute("data-theme-value") === theme));
    });
  };
  const applyTheme = (theme) => {
    const next = theme === "dark" ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", next);
    try { localStorage.setItem(THEME_KEY, next); } catch (e) {}
    syncThemeTabs(next);
  };
  applyTheme(document.documentElement.getAttribute("data-theme") || "light");
  document.addEventListener("click", (event) => {
    const btn = event.target.closest("[data-theme-switch] [data-theme-value]");
    if (!btn) return;
    applyTheme(btn.getAttribute("data-theme-value"));
  });

  // Home = fresh start: drop compare picks and load "/" with no filters, search or hash.
  const ROOT_PATH = (() => {
    try {
      return new URL(window.theme?.rootUrl || "/", location.origin).pathname.replace(/\/+$/, "") || "/";
    } catch (e) {
      return "/";
    }
  })();
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[href]");
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== "_self") return;
    let url;
    try {
      url = new URL(link.getAttribute("href"), location.href);
    } catch (e) {
      return;
    }
    if (url.origin !== location.origin) return;
    const path = url.pathname.replace(/\/+$/, "") || "/";
    if (path !== ROOT_PATH || (url.search && !url.searchParams.has("sfz"))) return;
    event.preventDefault();
    try {
      localStorage.removeItem("hyper-tech-compare");
    } catch (e) {}
    try { window.sfResetZoom?.(); } catch (e) {}
    const dest = `${ROOT_PATH === "/" ? "/" : ROOT_PATH}?sfz=${Date.now()}`;
    location.replace(dest);
  });

  const toggle = document.querySelector("[data-nav-toggle]");
  const nav = document.querySelector("[data-site-nav]");
  const backdrop = document.querySelector("[data-nav-backdrop]");
  const navHome = nav?.closest(".header-inner");
  function setNav(open) {
    if (!nav || !toggle) return;
    nav.classList.toggle("is-open", open);
    toggle.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", String(open));
    toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    document.body.classList.toggle("nav-open", open);
    const tools = navHome?.querySelector(".header-tools");
    if (open) {
      if (backdrop) document.body.append(backdrop, nav);
    } else if (navHome && tools) {
      navHome.insertBefore(nav, tools);
      if (backdrop) navHome.insertBefore(backdrop, tools);
    }
    if (backdrop) backdrop.hidden = !open;
  }
  toggle?.addEventListener("click", () => setNav(!nav.classList.contains("is-open")));
  backdrop?.addEventListener("click", () => setNav(false));
  nav?.querySelector("[data-nav-close]")?.addEventListener("click", () => setNav(false));
  nav?.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => setNav(false)));

  const searchToggle = document.querySelector("[data-search-toggle]");
  const searchWrap = document.querySelector("[data-exact-search]");
  const searchInput = searchWrap?.querySelector("input[name='q']");
  const searchClear = searchWrap?.querySelector("[data-search-clear]");
  const searchResults = searchWrap?.querySelector("[data-search-results]");
  const syncSearchClear = () => {
    if (!searchClear || !searchInput) return;
    searchClear.hidden = !String(searchInput.value || "").trim();
  };
  const setSearchOpen = (open) => {
    document.body.classList.toggle("header-search-open", open);
    searchToggle?.setAttribute("aria-expanded", String(open));
    if (open) {
      setNav(false);
      searchInput?.focus();
    } else {
      if (searchInput) searchInput.value = "";
      if (searchResults) {
        searchResults.hidden = true;
        searchResults.innerHTML = "";
      }
    }
    syncSearchClear();
  };
  searchToggle?.addEventListener("click", () => {
    setSearchOpen(!document.body.classList.contains("header-search-open"));
  });
  searchInput?.addEventListener("input", syncSearchClear);
  searchClear?.addEventListener("click", () => {
    if (window.innerWidth <= 860) setSearchOpen(false);
    else if (searchInput) {
      searchInput.value = "";
      searchInput.focus();
      if (searchResults) {
        searchResults.hidden = true;
        searchResults.innerHTML = "";
      }
      syncSearchClear();
    }
  });
  if (searchInput?.value) {
    syncSearchClear();
    if (window.innerWidth <= 860) setSearchOpen(true);
  }

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (document.body.classList.contains("header-search-open")) setSearchOpen(false);
    else setNav(false);
  });

  const topBtn = document.querySelector("[data-back-to-top]");
  const placeBackToTop = () => {
    if (!topBtn) return;
    const wa = document.getElementById("pushdaddy-button");
    const vv = window.visualViewport;
    const viewH = vv?.height || window.innerHeight;
    const insetBottom = Math.max(0, window.innerHeight - viewH - (vv?.offsetTop || 0));
    const waWidth = wa && wa.getBoundingClientRect().width > 20 ? wa.getBoundingClientRect().width : 56;
    topBtn.style.right = `${Math.round(16 + waWidth + 12)}px`;
    topBtn.style.bottom = `${Math.round(insetBottom + 16)}px`;
  };
  const toggleTopBtn = () => {
    if (!topBtn) return;
    const y = document.documentElement.classList.contains("search-open")
      ? Math.abs(parseInt(document.body.style.top || "0", 10)) || 0
      : window.scrollY;
    topBtn.hidden = y < 200;
    placeBackToTop();
  };
  window.addEventListener("scroll", toggleTopBtn, { passive: true });
  toggleTopBtn();
  topBtn?.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  const placeWhatsApp = () => {
    const btn = document.getElementById("pushdaddy-button");
    const box = document.getElementById("pushdaddy-box");
    if (!btn && !box) return;
    const vv = window.visualViewport;
    const viewH = vv?.height || window.innerHeight;
    const insetBottom = Math.max(0, window.innerHeight - viewH - (vv?.offsetTop || 0));
    const safe = 16;
    if (btn) {
      btn.style.setProperty("right", "16px", "important");
      btn.style.setProperty("bottom", `${Math.round(insetBottom + safe)}px`, "important");
    }
    placeBackToTop();
    if (!box) return;
    const open = getComputedStyle(box).display !== "none" && box.getBoundingClientRect().height > 40;
    document.body.classList.toggle("wa-open", open);
    if (!open) return;
    const mobile = window.innerWidth <= 860;
    const cap = mobile ? Math.min(430, Math.round(viewH * 0.62)) : 520;
    const maxH = Math.max(240, Math.min(cap, Math.round(viewH - 16)));
    const width = Math.min(376, Math.max(280, window.innerWidth - 16));
    box.style.setProperty("width", `${width}px`, "important");
    box.style.setProperty("max-width", `${window.innerWidth - 16}px`, "important");
    box.style.setProperty("height", `${maxH}px`, "important");
    box.style.setProperty("max-height", `${maxH}px`, "important");
    box.style.setProperty("right", "8px", "important");
    box.style.setProperty("bottom", `${Math.round(insetBottom + 8)}px`, "important");
    box.style.setProperty("top", "auto", "important");
    box.style.setProperty("left", "auto", "important");
  };
  let waTimer = 0;
  const scheduleWa = () => {
    clearTimeout(waTimer);
    waTimer = setTimeout(placeWhatsApp, 40);
  };
  const hideRespondioLauncher = () => {
    const open = document.body.classList.contains("sf-webchat-open");
    if (open) {
      document.querySelectorAll('#dbee1, iframe[title="Webchat Widget"]').forEach((el) => {
        el.style.removeProperty("display");
        el.style.removeProperty("visibility");
        el.style.removeProperty("opacity");
        el.style.removeProperty("pointer-events");
        el.removeAttribute("hidden");
        el.removeAttribute("aria-hidden");
      });
      return;
    }
    try {
      window.$respond?.do?.("chat:close");
    } catch {
      /* widget may still be loading */
    }
    document.querySelectorAll('#dbee1, iframe[title="Webchat Widget"]').forEach((el) => {
      el.style.setProperty("display", "none", "important");
      el.setAttribute("hidden", "");
      el.setAttribute("aria-hidden", "true");
    });
  };
  hideRespondioLauncher();
  placeWhatsApp();
  window.visualViewport?.addEventListener("resize", scheduleWa);
  window.visualViewport?.addEventListener("scroll", scheduleWa);
  window.addEventListener("resize", scheduleWa);
  document.addEventListener("click", () => setTimeout(placeWhatsApp, 80), true);
  new MutationObserver(() => {
    hideRespondioLauncher();
    scheduleWa();
  }).observe(document.body, { childList: true, subtree: true });
})();
